<script lang="ts">
	import Button from '../Button.svelte';
	import Dialog, { Title, Content, Actions } from '@smui/dialog/styled';
	import { getClient, mutate } from 'svelte-apollo';
	import { createEventDispatcher } from 'svelte';
	import LoadingOverlay from '../LoadingOverlay.svelte';
	import { removeMixedSegment, removeSegment } from '../../graphql/queries/segments';
	import type { DocumentNode } from 'graphql';

	export let mixed = false;

	let dispatch = createEventDispatcher();
	function dispatchDeleted() {
		dispatch('dispatchDeleted');
	}

	let removeSegmentDef: DocumentNode;

	if (mixed) {
		removeSegmentDef = removeMixedSegment;
	} else {
		removeSegmentDef = removeSegment;
	}

	const deleteIcon = '/assets/images/delete_icon.svg';
	const client = getClient();

	let dialog = false;
	let errorDialog = false;
	let errorMessage: string;
	let loading = false;
	export let id: string;
	export let name: string;

	function handleError(errMsg: string) {
		errorMessage = errMsg;
		errorDialog = true;
		console.error('Error deleting segment', errMsg);
	}

	const removeSegmentMutation = () => {
		loading = true;
		return new Promise((resolve) =>
			mutate(client, {
				mutation: removeSegmentDef,
				variables: {
					seg_id: id
				},
				errorPolicy: 'all'
			})
				.then((responseData) => {
					loading = false;
					const { errors } = responseData;
					if (errors) {
						console.log(errors);

						handleError(errors[0].message);
					} else {
						dispatchDeleted();
					}
				})
				.catch((err) => {
					loading = false;
					handleError(err.message);
					resolve({ errors: err });
				})
		);
	};
</script>

<button class="clickable" on:click={() => (dialog = true)}>
	<img class="small" src={deleteIcon} alt="Delete icon" />
</button>

<Dialog
	open={dialog}
	aria-labelledby="dialog-title"
	aria-describedby="dialog-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-title">Delete Segment</Title>
	<Content id="dialog-content">
		Do you really want to delete this segment - named
		<b>{name}</b>? Segment will NOT be also deleted from platform.
	</Content>

	<Actions>
		<Button
			on:click={() => {
				removeSegmentMutation();
				dialog = false;
			}}
		>
			Yes
		</Button>
		<Button variant="raised" on:click={() => (dialog = false)}>No</Button>
	</Actions>
</Dialog>

<Dialog
	open={errorDialog}
	aria-labelledby="dialog-title"
	aria-describedby="dialog-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-title">Error deleting segment</Title>
	<Content id="dialog-content">{errorMessage}</Content>

	<Actions>
		<Button
			on:click={() => {
				errorDialog = false;
				dispatchDeleted();
			}}
		>
			Close
		</Button>
	</Actions>
</Dialog>

<LoadingOverlay title="Deleting segment..." spinner visible={loading} />

<style>
	button {
		border: 0;
		background: none;
		border-radius: 6px;
	}

	button:hover {
		filter: invert(0.1);
	}

	.clickable {
		cursor: pointer;
	}

	img {
		width: 64px;
		display: block;
	}

	.small {
		width: 24px;
		margin: 0 -8px;
	}
</style>
